import Vue from 'vue'
import Vuetify from 'vuetify'
import axios from 'axios'
import VueAxios from 'vue-axios'
import FlagIcon from 'vue-flag-icon'
import 'vuetify/dist/vuetify.min.css'
import VueGtag from 'vue-gtag'
import App from '@/App'
import router from '@/router'

/* intialize Vue and Vuetify */

Vue.use(Vuetify, {
  theme: {
    primary: '#5445D3',
    secondary: '#5445D3',
    accent: '#E26557',
    error: '#EB5757',
    warning: '#FBCE2F',
    info: '#2D9CDB',
    success: '#27AE60'
  }
}
)
Vue.use(VueAxios, axios)
Vue.use(FlagIcon)
Vue.config.productionTip = false

// connecting to google analytics
Vue.use(VueGtag, {
  config: { id: 'UA-167477938-1' }
}, router)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js